import { motion } from 'framer-motion'
import Reveal from './Reveal'

const testimonios = [
  {
    initials: 'ML',
    name: 'María Laura G.',
    course: 'Cardiología Clínica Avanzada',
    text: 'El curso fue un antes y un después. Explica de una forma que ningún libro o video había logrado. Aprobé mi primer año en mi primer intento.',
  },
  {
    initials: 'CR',
    name: 'Carlos R.',
    course: 'Mentoría 1 a 1',
    text: 'La mentoría cambió completamente mi forma de estudiar. Dos veces cursé el primer año. En 3 meses con Dante avancé más que en los 2 años anteriores estudiando solo. Vale cada centavo, me hubiera gustado conocerlo antes para no perder tanto tiempo.',
  },
  {
    initials: 'SP',
    name: 'Sofía P.',
    course: 'Mentoría 1 a 1',
    text: 'Dante, no sé cómo darte las gracias por la tremenda ayuda que me diste todo este tiempo. Las palabras se quedan cortas. No es solo el hecho de haber logrado aprobar gracias a los conocimientos que me brindaste... es mucho más que eso. Es tu buena onda, tu dedicación y esas frases motivadoras que siempre nos decís para que nunca bajemos los brazos. ¡Muchas gracias, Dan! Ya estoy a mitad del camino del primer año... ¡y vamos por más!',
  },
  {
    initials: 'MR',
    name: 'Martín R.',
    course: 'Intensivo · Modalidad virtual',
    text: 'El año pasado cursé el intensivo antes del primer parcial de manera presencial y aprobé muy bien. Este año opté por la modalidad virtual... y tengo que decir que me sirvieron muchísimo las clases online. Incluso puedo decir que, para mí, fueron mejores que la presencialidad. Los recursos visuales me ayudaron un montón y me facilitaron el aprendizaje. ¡Gracias! Estoy súper contento.',
  },
]

function Stars() {
  return (
    <div className="flex gap-1 mb-5">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="12" height="12" viewBox="0 0 12 12">
          <path
            d="M6 0.5l1.545 3.13 3.455.502-2.5 2.437.59 3.44L6 8.33 2.91 9.91l.59-3.44L1 4.132l3.455-.501z"
            fill="#C9A84C"
          />
        </svg>
      ))}
    </div>
  )
}

function MoleculeAccent() {
  return (
    <svg
      width="320" height="320" viewBox="0 0 320 320" fill="none"
      className="absolute -bottom-16 -left-16 opacity-[0.03] pointer-events-none"
    >
      <circle cx="160" cy="160" r="120" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="160" cy="160" r="80" stroke="#C9A84C" strokeWidth="0.5"/>
      <circle cx="160" cy="40" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="160" cy="280" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="40" cy="160" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="280" cy="160" r="12" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="75" cy="75" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <circle cx="245" cy="75" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <circle cx="75" cy="245" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <circle cx="245" cy="245" r="8" stroke="#C9A84C" strokeWidth="0.8"/>
      <line x1="160" y1="40" x2="160" y2="280" stroke="#C9A84C" strokeWidth="0.4"/>
      <line x1="40" y1="160" x2="280" y2="160" stroke="#C9A84C" strokeWidth="0.4"/>
      <line x1="75" y1="75" x2="245" y2="245" stroke="#C9A84C" strokeWidth="0.4"/>
      <line x1="245" y1="75" x2="75" y2="245" stroke="#C9A84C" strokeWidth="0.4"/>
    </svg>
  )
}

export default function Testimonios() {
  return (
    <section
      id="testimonios"
      className="relative overflow-hidden"
      style={{ padding: '120px 5vw', background: 'var(--bg)' }}
    >
      <MoleculeAccent />

      <div className="relative z-10">
        <Reveal>
          <div className="section-label">Testimonios</div>
          <h2
            className="font-display font-black leading-[1.04] tracking-[-0.02em] mb-16"
            style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', color: 'var(--ink)' }}
          >
            Lo que dicen quienes ya<br />
            <em className="not-italic" style={{ color: 'var(--gold)' }}>
              transformaron
            </em>{' '}
            su carrera.
          </h2>
        </Reveal>

        {/* Grid 2x2 para 4 testimonios */}
        <div
          className="grid grid-cols-1 md:grid-cols-2"
          style={{ gap: '1px', background: 'var(--line)' }}
        >
          {testimonios.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ backgroundColor: 'rgba(22,22,22,1)' }}
              className="flex flex-col justify-between"
              style={{ background: 'var(--bg)', padding: '40px' }}
            >
              <div>
                <Stars />
                <div
                  className="font-display font-black leading-[0.8] mb-3 opacity-30"
                  style={{ fontSize: '40px', color: 'var(--gold)' }}
                >
                  "
                </div>
                <p
                  className="font-body font-light text-[14px] leading-[1.85] italic mb-8"
                  style={{ color: 'var(--ink-2)' }}
                >
                  {t.text}
                </p>
              </div>

              <div
                className="flex items-center gap-3.5 pt-6"
                style={{ borderTop: '1px solid var(--line-2)' }}
              >
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center shrink-0 font-display font-black text-[11px]"
                  style={{
                    background: 'rgba(201,168,76,0.1)',
                    border: '1px solid var(--line)',
                    color: 'var(--gold)',
                  }}
                >
                  {t.initials}
                </div>
                <div>
                  <div
                    className="font-display font-bold text-[13px]"
                    style={{ color: 'var(--ink)' }}
                  >
                    {t.name}
                  </div>
                  <div
                    className="font-body text-[11px] mt-0.5"
                    style={{ color: 'var(--ink-3)' }}
                  >
                    {t.course}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}